import React, {useEffect} from "react";
import {LoadingBox} from "~/apps/core/ui/LoadingBox";
import {List, ListItem} from "@mui/material";
import {OrdersListItem} from "~/apps/packages/auto-shipment-orders/components/OrdersList/OrdersListItem";
import {useAutoShipmentOrdersList} from "~/apps/packages/auto-shipment-orders/hooks";
import {findScrollableNode, useBottomScrollListener} from "~/lib/useBottomScrollListener";
import {useHistory} from "react-router-dom";
import {ShortCargo} from "~/apps/packages/cargos/queries";
import {OrderItem} from "~/apps/packages/auto-shipment-orders/queries";

export type OrdersListProps = {
    dateFrom?: Date
    dateTo?: Date
    query?: string
    statuses?: OrderItem["status"][]
}

export const OrdersList = (props: OrdersListProps) => {
    const { dateTo, dateFrom, query, statuses } = props;
    const history = useHistory();
    const { data, loading, canFetchMore, fetchMore } = useAutoShipmentOrdersList({
        status: statuses,
        dateTo: dateTo,
        dateFrom: dateFrom,
        query: query,
    });

    const setScrollNode = useBottomScrollListener(() => {
        fetchMore();
    }, 50, 100, false);

    useEffect(() => {
        if (data) {
            //onChange && onChange({count: data.length || 0});
        }
    }, [data]);

    useEffect(() => {
        //onLoading && onLoading(loading);
    }, [loading]);

    const handleItemClick = (item: { id: string }) => {
        history.push(`/${encodeURI(item.id)}`);
    }

    const handleRef = (node) => {
        setScrollNode(findScrollableNode(node));
    }

    return (
        <LoadingBox isInitialLoading={data == undefined} loading={loading} empty={data?.length == 0} placeholder={canFetchMore}>
            {data?.length > 0 && (
                <List ref={handleRef}>
                    {
                        data.map((item) =>  <ListItem onClick={() => handleItemClick(item)} key={`${item.id}`}>
                            <OrdersListItem offer={item} />
                        </ListItem>)
                    }
                </List>)}
        </LoadingBox>
    );
}
